export default "/images/horizontal-logo-color.png?8552bdb0f17fa326a5809d8d28418cc5";